import { useState } from 'react'
import { useAuthStore } from '@auth/authStore'
import { tokenStore} from '@auth/tokenStore'
import { authService } from '../services/authService'

function useAuth() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const setAuth = useAuthStore((state) => state.setAuth);

  const login = async (email, password) => {
    setIsLoading(true)
    setError(null)
    try {
      const { result, error } = await authService.login(email, password)
      if (result) {
        tokenStore.setTokens(result.AccessToken, result.IdToken)
        setAuth({
          user: result.UserID,
          userFirstName: result.UserFirstName,
          userLastName: result.UserLastName,
          companyID: result.CompanyID,
          companyName: result.CompanyName,
          isAuthenticated: true
        })
        return true
      }
      setError(error)
    } catch (err) { 
      setError(err.message || 'Login failed')
      return false
    } finally {
      setIsLoading(false)
    }
  }

    const logout = () => {
        useAuthStore.getState().logout();
    };

    return { login, logout, isLoading, error };
};

export default useAuth;